import React from 'react';
import InboxButton from '../InboxButton/InboxButton';
import SearchButton from '../SearchButton/SearchButton';
import LoginButton from '../LoginButton/LoginButton';
import ProfileDropdown from '../Profiledropdown/ProfileDropdown';
import styles from './HeaderControls.module.scss';

export type HeaderItemsProps = { isLoggedIn?: boolean; shouldOpen?: boolean };

const AuthenticatedHeaderItems = ({ shouldOpen }: HeaderItemsProps) => {
  return (
    <>
      <SearchButton/>
      <InboxButton/>
      <ProfileDropdown shouldOpen={shouldOpen} />
    </>
  );
};

const DefaultHeaderItems = () => {
  return (
    <>
      <SearchButton/>
      <LoginButton/>
    </>
  );
};

const HeaderControlsNoWrapper = ({ isLoggedIn, shouldOpen }: HeaderItemsProps) => {
  return (
    <div className={styles.dnbHeaderControls}>
      {isLoggedIn ? (
        <AuthenticatedHeaderItems shouldOpen={shouldOpen} />
      ) : (
        <DefaultHeaderItems />
      )}
    </div>
  );
};

export default HeaderControlsNoWrapper;
